// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plex-update-details-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Changed from center to flex-start */
  min-height: 100%;
  background-color: var(--background);
  padding: 1rem 0;
  overflow-y: auto;
  position: relative;
  height: calc(100vh - 60px); /* Adjust this value based on your navbar height */
}

.plex-update-details-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background-color: var(--background-consistent);
  border-radius: 0.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
  /* width: 90%; */
  max-width: 500px;
  margin: 16px;
  overflow-y: visible;
  text-align: center;
}

.plex-update-details-form input {
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.plex-update-details-form .plex-update-details-submit-btn {
  width: 100%;
  padding: 0.5rem;
  margin: 1rem 0;
  background-color: var(--theme-consistent);
  color: #ffffff;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.plex-update-details-form input,
.plex-update-details-form .plex-update-details-submit-btn {
  width: 100%;
  max-width: 400px;
}

.plex-update-details-form h2 {
  margin-bottom: 1.5rem;
}

.plex-update-details-form .plex-update-details-submit-btn:hover {
  background-color: var(--theme-consistent);
}

.plex-update-details-error {
  color: #FF3A31;
  margin-top: 1rem;
  text-align: center;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.plex-address-info {
  text-align: center;
  margin-bottom: 1rem;
  width: 100%;
  max-width: 400px;
}

.plex-address-info h4 {
  margin-bottom: 0.5rem;
}

.plex-address-info p {
  color: #FF3A31;
  font-weight: bold;
}

/* Mobile specific adjustments */
@media screen and (max-width: 768px) {
  .plex-update-details-container {
    height: calc(100vh - 80px); /* Adjust based on mobile navbar height */
    padding: 0.5rem 0;
  }

  .plex-update-details-form {
    padding: 2rem;
    /* width: 95%; */
    margin: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/PlexUpdateDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B,EAAE,sCAAsC;EACnE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B,EAAE,kDAAkD;AAChF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE;IACE,0BAA0B,EAAE,yCAAyC;IACrE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".plex-update-details-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start; /* Changed from center to flex-start */\n  min-height: 100%;\n  background-color: var(--background);\n  padding: 1rem 0;\n  overflow-y: auto;\n  position: relative;\n  height: calc(100vh - 60px); /* Adjust this value based on your navbar height */\n}\n\n.plex-update-details-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  background-color: var(--background-consistent);\n  border-radius: 0.5rem;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  font-size: 1rem;\n  /* width: 90%; */\n  max-width: 500px;\n  margin: 16px;\n  overflow-y: visible;\n  text-align: center;\n}\n\n.plex-update-details-form input {\n  width: 100%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.plex-update-details-form .plex-update-details-submit-btn {\n  width: 100%;\n  padding: 0.5rem;\n  margin: 1rem 0;\n  background-color: var(--theme-consistent);\n  color: #ffffff;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.plex-update-details-form input,\n.plex-update-details-form .plex-update-details-submit-btn {\n  width: 100%;\n  max-width: 400px;\n}\n\n.plex-update-details-form h2 {\n  margin-bottom: 1.5rem;\n}\n\n.plex-update-details-form .plex-update-details-submit-btn:hover {\n  background-color: var(--theme-consistent);\n}\n\n.plex-update-details-error {\n  color: #FF3A31;\n  margin-top: 1rem;\n  text-align: center;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.plex-address-info {\n  text-align: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  max-width: 400px;\n}\n\n.plex-address-info h4 {\n  margin-bottom: 0.5rem;\n}\n\n.plex-address-info p {\n  color: #FF3A31;\n  font-weight: bold;\n}\n\n/* Mobile specific adjustments */\n@media screen and (max-width: 768px) {\n  .plex-update-details-container {\n    height: calc(100vh - 80px); /* Adjust based on mobile navbar height */\n    padding: 0.5rem 0;\n  }\n\n  .plex-update-details-form {\n    padding: 2rem;\n    /* width: 95%; */\n    margin: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
